import { Navigate, Route, Routes } from "react-router-dom";
import Landing from "@/pages/Landing";
import AgentPage from "@/pages/AgentPage";
import ProgramPage from "@/pages/ProgramPage";
import Contact from "@/pages/Contact";
import FounderStory from "@/pages/FounderStory";
import Academy from "@/pages/Academy";
import AIAgents from "@/pages/AIAgents";
import WearableIntegrations from "@/pages/WearableIntegrations";
import MedicalCare from "@/pages/MedicalCare";
import WellnessOptimization from "@/pages/WellnessOptimization";
import MedicalDirector from "@/pages/MedicalDirector";
import BiologicalAge from "@/pages/BiologicalAge";
import GetStarted from "@/pages/GetStarted";
import Quiz from "@/pages/Quiz";
import IntentPage from "@/pages/IntentPage";
import EvidenceLibrary from "@/pages/EvidenceLibrary";
import EvidencePage from "@/pages/EvidencePage";
import Organizations from "@/pages/Organizations";
import Technology from "@/pages/Technology";
import TeamPage from "@/pages/TeamPage";
import SampleAnalysis from "@/pages/SampleAnalysis";
import Updates from "@/pages/Updates";
import NotFound from "@/pages/NotFound";
import { INTENT_SLUGS } from "@/data/intentPages";
import { EVIDENCE_SLUGS } from "@/data/evidencePages";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/agents/mira" element={<Navigate to="/agents/rhea" replace />} />
      <Route path="/agents/:id" element={<AgentPage />} />
      <Route path="/programs/:slug" element={<ProgramPage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/founder-story" element={<FounderStory />} />
      <Route path="/academy" element={<Academy />} />
      <Route path="/ai-agents" element={<AIAgents />} />
      <Route path="/wearable-integrations" element={<WearableIntegrations />} />
      <Route path="/medical-care" element={<MedicalCare />} />
      <Route path="/wellness-optimization" element={<WellnessOptimization />} />
      <Route path="/medical-director" element={<MedicalDirector />} />
      <Route path="/biological-age" element={<BiologicalAge />} />
      <Route path="/get-started" element={<GetStarted />} />
      <Route path="/quiz" element={<Quiz />} />
      {INTENT_SLUGS.map((slug) => <Route key={slug} path={`/${slug}`} element={<IntentPage slug={slug} />} />)}
      <Route path="/evidence" element={<EvidenceLibrary />} />
      {EVIDENCE_SLUGS.map((slug) => <Route key={slug} path={`/evidence/${slug}`} element={<EvidencePage slug={slug} />} />)}
      <Route path="/organizations" element={<Organizations />} />
      <Route path="/technology" element={<Technology />} />
      <Route path="/team" element={<TeamPage />} />
      <Route path="/sample-analysis" element={<SampleAnalysis />} />
      <Route path="/updates" element={<Updates />} />
      <Route path="/programs" element={<Navigate to="/#programs" replace />} />
      <Route path="/how-it-works" element={<Navigate to="/#how-it-works" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}